import type { MeResponse } from '@getslot/api-client'
import { queryOptions } from '@tanstack/react-query'
import { api } from './session'

export const meQuery = queryOptions({
  queryKey: ['me'],
  queryFn: ({ signal }) => api.get<MeResponse>('/me', { signal }),
  staleTime: 5 * 60_000,
})
